import React, { useEffect } from "react";
import "./CompletionCard.scss";
import { completionCardInterface } from "../../../interfaces";
import { Card, CardContent } from "@material-ui/core";
import moment from "moment";
import CompletionCertificate from "./CompletionCertificate";
import BadgeContent from "./badgeContent";
import { useSelector } from "react-redux";
import { soloProducts } from "../../../globalConstants";
import translate from "../../../i18n/translate";

const CompletionCard = (props: completionCardInterface) => {
  const allInfo = useSelector((state: any) => state);
  const timeSpentInReach = moment()
    .startOf("day")
    .seconds(props.cardData["TimeInReach"] || 0)
    .format("HH:mm");
  const [selectedproductID, setProductID] = React.useState("");
    
  // PROP TYPES:
  /*-- SPRINT BUSINESS SKILLS --
    0. Prework completed
    1. Homework completed
    2. Total sessions completed
    3. Certificate
    -- REACH --
    4. Skills completed
    5. Badges earned
    6. Missions passed
    7. Time in Reach
    8. Milestone badges
  */
  const [dialogContent, setDialogContent]= React.useState<any>();
  useEffect(() => {
    if(props.type==="3" ||props.type==="8") {
      let dialogContentLocal=(
        <div>
          <h6>{translate("progress_overall_card_title_certificate")}:</h6>
          <p>{translate("progress_badge_dialog_box_title")}</p>
          <h6>{translate("progress_overall_card_title_badge")}:</h6>
          <ul>
            <li>{translate("progress_badge_dialog_box_golden")}</li>
            <li>{translate("progress_badge_dialog_box_silver")}</li>
            <li>{translate("progress_badge_dialog_box_bronze")}</li>
          </ul>
          <p>
            {(allInfo.common.productID==="21" || allInfo.common.productID==="22"|| allInfo.common.productID==="23"|| allInfo.common.productID==="24") && <>*{translate("progerss_badge_dailog_box_digitalActivities")}.</>
            }
             {(allInfo.common.productID=="20" || allInfo.common.productID=="18") &&             
              <>*{translate("progress_badge_dailog_box_liveSessions")}.</>
            }
          </p>
        </div>
      );
      setDialogContent(dialogContentLocal);
    }
  },[props]);

  return (
    <div>
      {props.type === "0" && (
        <Card className="completion-card">
          <CardContent className="completion-card-body">
            <div>
              <div className="completion-card-title">
                <div>
                  <div className="completion-number">
                    {Math.round((props.cardData.prework / props.cardData.totalprework) * 100)
                      ? Math.round((props.cardData.prework / props.cardData.totalprework) * 100)
                      : 0}
                    %
                  </div>
                  <div className="completion-label">{props.title}</div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      {props.type === "1" && (
        <Card className="completion-card">
          <CardContent className="completion-card-body">
            <div>
              <div className="completion-card-title">
                <div>
                  <div className="completion-number">
                    {Math.round((props.cardData.homework / props.cardData.totalhomework) * 100)
                      ? Math.round((props.cardData.homework / props.cardData.totalhomework) * 100)
                      : 0}
                    %
                  </div>
                  <div className="completion-label">{props.title}</div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      {props.type === "2" && (
        <Card className="completion-card">
          <CardContent className="completion-card-body">
            <div>
              <div className="completion-card-title">
                <div>
                  <div className="completion-number">
                    {props.cardData.sessions + "/" + props.cardData.totalsessions}
                  </div>
                  <div className="completion-label">{props.title}</div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      {props.type === "3" && (
        <Card className="completion-card">
          <CardContent className="completion-card-body">
            <div>
              <CompletionCertificate cardData={props.cardData} partTitle={props.partTitle} dialogContent={dialogContent}>
              </CompletionCertificate>
            </div>
          </CardContent>
        </Card>
      )}
      {props.type === "4" && (
        <Card className="completion-card">
          <CardContent className="completion-card-body">
            <div>
              <div className="completion-card-title">
                <div>
                  <div className="completion-number">
                    {props.cardData["ReachSkillsCompleted"] ? props.cardData["ReachSkillsCompleted"] : "0"}
                  </div>
                  <div className="completion-label">{props.title}</div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      {props.type === "5" && (
        <Card className="completion-card">
          <CardContent className="completion-card-body">
            <div>
              <div className="completion-card-title">
                <div>
                  <div className="completion-number">
                    {props.cardData["ReachBadgesEarned"] ? props.cardData["ReachBadgesEarned"] : "0"}
                  </div>
                  <div className="completion-label">{props.title}</div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      {props.type === "6" && (
        <Card className="completion-card">
          <CardContent className="completion-card-body">
            <div>
              <div className="completion-card-title">
                <div>
                  <div className="completion-number">
                    {props.cardData["ReachMissionsPassed"] ? props.cardData["ReachMissionsPassed"] : "0"}
                  </div>
                  <div className="completion-label">{props.title}</div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      {props.type === "7" && (
        <Card className="completion-card">
          <CardContent className="completion-card-body">
            <div>
              <div className="completion-card-title">
                <div>
                  <div className="completion-number">{props.cardData["TimeInReach"] ? timeSpentInReach : "00:00"}</div>
                  <div className="completion-label">{props.title}</div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      {props.type === "8" && !!dialogContent && !!!(soloProducts.filter((solo: any)=> solo=== allInfo.common.productID).length>0) && (
        <Card className="completion-card">
          <CardContent className="completion-card-body">
            <div className="certificate-placement">
              <BadgeContent cardData={props.cardData} partTitle={props.partTitle} dialogContent={dialogContent}></BadgeContent>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default CompletionCard;
